<template>
  <div class="page-content conmon-top">
    <div class="base-input ovf-hd" style="margin-bottom: 10px;">
      <el-row class="search-title">
        <el-col :span="4" class="search-nav-left">
          <i class="el-icon-search" style="font-weight: bold;"></i>
          <span class="order-list-search-span">筛选查询</span>
        </el-col>
        <el-col :span="20" class="search-nav-right">
          <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="hide">收起查询</el-button>
          <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="!hide">展开查询</el-button>
          <i v-if="hide === true" class="el-icon-arrow-up search-open-close-i" @click="hide=!hide"></i>
          <i v-if="hide === false" class="el-icon-arrow-down search-open-close-i" @click="hide=!hide"></i>
          <el-button class="search-btn-new" type="primary" size="small" @click="searchLoad">查询</el-button>
        </el-col>
      </el-row>
      <el-collapse-transition>
        <div v-show="hide" class="search-content common-search-formtype">
          <el-form :inline="true" :model="formInlineTmp" label-width="95px" class="search-content-item">
            <el-form-item label="状态:">
              <el-select v-model="formInlineTmp.status" placeholder="请选择">
                <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="券ID:">
              <el-input v-model.trim="formInlineTmp.code" placeholder="" clearable ></el-input>
            </el-form-item>
            <el-form-item label="领取人:">
              <el-input v-model.trim="formInlineTmp.user_name" placeholder="" clearable ></el-input>
            </el-form-item>
            <el-form-item label="使用终端:">
              <el-input v-model.trim="formInlineTmp.terminal" placeholder="" clearable ></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-collapse-transition>
    </div>
    <el-row class="search-title common-table-top" style="padding-right:0">
      <el-col :span="4" style="text-align: left;">
        <i class="el-icon-document" style="font-weight: bold;"></i>
        <span class="order-list-search-span">数据列表</span>
      </el-col>
      <el-col :span="20" class="text-align-right">
        <el-button type="primary" @click="pushToExport" class="add-btn btn-right" style="float: right;">导出</el-button>
      </el-col>
    </el-row>
    <el-row class="import-data-title table-first-style">
      <el-table :data="tableData" v-loading="loading" class="table">
        <el-table-column label="券ID" width="300">
          <template slot-scope="scope">
            {{ scope.row.code }}
          </template>
        </el-table-column>
        <el-table-column label="创建时间">
          <template slot-scope="scope">
            {{ scope.row.create_time | formatDate }}
          </template>
        </el-table-column>
        <el-table-column label="领取时间">
          <template slot-scope="scope">
            {{ scope.row.receive_time }}
          </template>
        </el-table-column>
        <el-table-column label="领取人">
          <template slot-scope="scope">
            {{ scope.row.use_name }}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 0" style="color: orange;font-size:12px">未领取</span>
            <span v-if="scope.row.status === 10" style="color: #05B324;font-size:12px">未使用</span>
            <span v-if="scope.row.status === 20" style="color: #FF2B2B;font-size:12px">已使用</span>
          </template>
        </el-table-column>
        <el-table-column label="使用时间">
          <template slot-scope="scope">
            {{ scope.row.use_time }}
          </template>
        </el-table-column>
        <el-table-column width='120' label="使用终端">
          <template slot-scope="scope">
            {{ scope.row.terminal_name }}
          </template>
        </el-table-column>
        <el-table-column width='120' label="终端手机号">
          <template slot-scope="scope">
            {{ scope.row.phone }}
          </template>
        </el-table-column>
        <el-table-column width='120' label="商品名称">
          <template slot-scope="scope">
            {{ scope.row.pro_name }}
          </template>
        </el-table-column>
      </el-table>
      <div class="table-foot">
        <el-pagination class="table-foot-pagination" background @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="limit" layout="total, prev, pager, next, jumper" :total="totalCount">
        </el-pagination>
      </div>
    </el-row>
  </div>
</template>
<script>
import { getCouponCodes, exportCoupons } from '@/api/yunzhong.js'
export default {
  name: 'list',
  data() {
    return {
      id: 0,
      loading: true,
      statusOptions: [
        {
          label: '全部',
          value: ''
        },
        {
          label: '未领取',
          value: '1'
        },
        {
          label: '未使用',
          value: '2'
        },
        {
          label: '已使用',
          value: '3'
        }
      ],
      hide: true,
      tableData: [],
      page: 1,
      totalCount: 0,
      formInlineTmp: {},
      formInline: {},
      limit: 10,
    }
  },
  methods: {
    searchLoad() {
      this.page = 1
      this.formInline = JSON.parse(JSON.stringify(this.formInlineTmp))
      this.getData()
    },
    // 处理分页
    handleSizeChange(val) {
      this.limit = val
    },
    handleCurrentChange(page) {
      //console.log('handleCurrentChangethis.formInline', this.formInline)
      this.page = page
      this.getData()
    },
    //导出
    pushToExport() {
      exportCoupons(this.id, this.formInline).then(res => {
        //console.log(res);
        this.download(res)
      })
    },
    // 下载文件
    download (data) {
      if (!data) {
        return
      }
      var now = new Date()
      var year = now.getFullYear()
      var month = (now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : (now.getMonth()) + 1)
      console.log(month)
      var date = now.getDate()
      var hour = now.getHours()
      var minute = now.getMinutes()
      var second = now.getSeconds()
      let time = ''
      time = year + '' + month + '' + date + '' + hour + '' + minute + '' + second
      var blob = new Blob([data.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' }) // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
      var downloadElement = document.createElement('a')
      var href = window.URL.createObjectURL(blob) // 创建下载的链接
      downloadElement.href = href
      downloadElement.download = time + '.xlsx' // 下载后文件名
      document.body.appendChild(downloadElement)
      downloadElement.click() // 点击下载
      document.body.removeChild(downloadElement) // 下载完成移除元素
      window.URL.revokeObjectURL(href) // 释放掉blob对象
    },
    getData() {
      this.loading = true
      getCouponCodes(this.id, this.page, this.formInline).then(res => {
        this.tableData = res.data.data.list
        this.totalCount = res.data.data.count
      })
      this.openLoading()
    },
    // 数据加载时的动画
    openLoading() {
      setTimeout(() => {
        this.loading = false
      }, 500)
    }
  },
  created() {
    this.id = this.$route.query.id
    this.getData()
  },
  components: {}
}
</script>
<style scoped>
.sign-manage-title {
  height: 40px;
}

.content-one span {
  display: inline-block;
  float: left;
  line-height: 20px;
  font-size: 16px;
  margin-top: 10px;
}

.content-one p {
  text-align: left;
}
</style>
